import { defineComponent as _defineComponent } from 'vue'
import { getDateFormatted, getTimeFormatted12Hours } from '@/services/date'
import { mdiCalendarCheckOutline, mdiClockOutline } from '@mdi/js'
import { IEventEdit } from '@/enitites/event'
import { centsToDollars } from '@/services/currency'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventTicketsDiscounts',
  props: {
    eventData: null
  },
  setup(__props: any) {

const props = __props as {
  eventData: IEventEdit
};



const getTiersForDiscount = (tierIds: number[]) => {
  return props.eventData.tiers?.filter((tier) => tierIds.includes(tier.id)) || []
}

return { __sfc: true,props, getTiersForDiscount, getDateFormatted, getTimeFormatted12Hours, mdiCalendarCheckOutline, mdiClockOutline, centsToDollars }
}

})